import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../../../../components/forms/index"
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import url from "../../../../config/axios";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const ManufacturerUpdate = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const imageUrl = useSelector((state) => state.imgurl);
  const [displayimg, setDisplayimg] = useState();
  const [shopCategoryone, setShopCategoryone] = useState();
    const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isloading, setIsloading] = useState(false);
  const { id } = useParams();


  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });

  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);

  const onDrop = async (acceptedFiles) => {
    try {
        setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });
  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    businessType: "manufacturerShop",
    marketPlace: "",
    shopCategory: categoryid,
    description: "",
    status: true
  })
  useEffect(() => {
    setCreateShop((createShop) => ({
      ...createShop,
      image: imageUrl?.imgurl || "",
    }));
    // ...
  }, [imageUrl]);

  useEffect(() => {
    url
      .get("category/type/?type=manufacturerShop&parentCategory=")
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategoryone(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
      });
  }, []);

  useEffect(() => {
    setIsloading(true);
    url.get(`shop/id?id=${id}`).then(async (response) => {
      if (response.data.success) {
        setIsloading(false);
      }
      setCreateShop(response?.data?.data?.Shop)
    }).catch((error) => {
      setIsloading(false);
      console.log("error", error)
    })
  }, [])

  const UpdateShop = (e) => {
    setIsloading(true);
    e.preventDefault();
    url
      .put(`shop/id?id=${id}`, createShop)
      .then(async (response) => {
        if (response?.data?.success) {
          setIsloading(false);
          setTimeout(() => {
            SuccessNotify("Form Update Successfully");
            navigate("/manufacturer-owner-profile/" + id);
          }, 1000);
        }
      })
      .catch((error) => {
        setIsloading(false);
        FailedNotify("Failed to Update");
      });
  };

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }
  return (
    <Form
      title="Fill to update Manufacturer Shop"
      butn="Update"
      navigateTo="/manufacturer-owner-profile"
      back="/manufacturer-owner-profile/"
      UpdateShop={UpdateShop}
      createShop={createShop}
      link="/manufacturer-update/"
      shopCategoryone={shopCategoryone}
      setCreateShop={setCreateShop}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      id={id}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      Shopdatas={Shopdatas}
      isUploading={isUploading}           
      uploadProgress={uploadProgress} 
    />
  );
};
export default ManufacturerUpdate;
